import cx from 'classnames';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import React, { FC, ReactNode } from 'react';
import { PropsWithClassName } from '@/types/common';
import ArrowIcon from '@/assets/icons/arrow.svg';
import Button, { ButtonVariant } from '@/components/Common/Button';
import * as styles from './DownloadButton.module.scss';

type Props = PropsWithClassName<{
  file?: Queries.DatoCmsDownloadFragment;
  title?: ReactNode;
}>;

const DownloadButton: FC<Props> = ({ className, file, title = i18n._(t`Download`) }) => (
  <Button
    className={cx(styles.main, className)}
    as="a"
    variant={ButtonVariant.Ghost}
    href={file?.url}
    target="_blank"
    rel="noopener noreferrer"
    download
  >
    <ArrowIcon className={styles.arrow} />
    {title ?? file?.title}
  </Button>
);

export default DownloadButton;
